<template>
    <common-modal :heading="heading">
        <common-page-plain>
            <common-content-wrapper width="medium">
                <common-buttons>
                    <common-button
                        type="secondary"
                        :isProcessing="isLoading"
                        :label="$t('common.microcopy.false')"
                        @click="emitEvent({ name: 'close' })"
                    ></common-button>
                    <common-button
                        type="primary"
                        :isProcessing="isLoading"
                        :label="$t('common.microcopy.true')"
                        @click="emitEvent({ name: 'accepted' })"
                    ></common-button>
                </common-buttons>
            </common-content-wrapper>
        </common-page-plain>
    </common-modal>
</template>

<script>
    export default {
        props: {
            isLoading: { type: Boolean, default: false },
            heading: { type: String, required: true },
        },
    }
</script>
